import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./Policies.css";

const ReviewPolicy: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className='policy-container'>
            <button className="back-button" onClick={() => navigate(-1)}>
                ← Back
            </button>
            <h1>Review Policy</h1>
            <p className="policy-intro">Last Updated: January 5, 2025</p>

            <section className="review-section">
                <h2 className="section-title">Introduction</h2>

                <div className="content-block">
                    <p>
                        At Fervoir, we value authentic feedback to help users make informed decisions. To maintain a fair and trustworthy platform, we manually review all submitted reviews before they are published.
                    </p>
                </div>

                <h2 className="section-title">What We Approve</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Provide honest feedback—whether positive or negative.</li>
                        <li>Are relevant to the platform (e.g., experiences with matches, app usability, customer support).</li>
                        <li>Are respectful and free from hate speech, threats, or personal attacks.</li>
                        <li>Contain real experiences rather than fabricated or misleading claims.</li>
                    </ul>
                </div>

                <h2 className="section-title">What We Do Not Approve</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Contain spam (e.g., repeated posts, promotional links, or advertisements).</li>
                        <li>Are completely irrelevant (e.g., random text, inside jokes, or personal messages unrelated to the platform).</li>
                        <li>Include offensive, hateful, or discriminatory language.</li>
                        <li>Are fake or deceptive, such as reviews left by bots or users with no genuine experience.</li>
                        <li>Violate privacy by sharing personal or sensitive information about another user.</li>
                    </ul>
                </div>

                <h2 className="section-title">How Our Review Process Works</h2>
                <div className="content-block">
                    <ul className="list">
                        <li>Every review is manually checked within [X hours/days].</li>
                        <li>If a review meets our guidelines, it is published as submitted.</li>
                        <li>If a review is rejected, the user may be notified and given the opportunity to resubmit following the guidelines.</li>
                    </ul>
                    <p>
                        For any concerns about reviews, contact us at <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>.
                    </p>
                </div>
            </section>

            <section className="updates-section">
                <h2 className="section-title">Updates to These Policies</h2>
                <div className="content-block">
                    <p>
                        We reserve the right to update these policies at any time.
                    </p>
                    <ul className="list">
                        <li>Significant changes will be communicated to users via the app and/or email.</li>
                        <li>Continued use of Fervoir after changes constitutes acceptance of the new policies.</li>
                    </ul>
                </div>
            </section>

            <section className="contact-section">
                <h2 className="section-title">Contact Us</h2>
                <div className="content-block">
                    <p>For any questions, concerns, or feedback, please contact us at:</p>
                    <p>
                        Email: <a href="mailto:paulfortuneltd@gmail.com" className="email">paulfortuneltd@gmail.com</a>
                    </p>
                </div>
            </section>
        </div>
    );
};

export default ReviewPolicy;